import { render, staticRenderFns } from "./HazardView.vue?vue&type=template&id=428e7e17"
import script from "./HazardView.vue?vue&type=script&setup=true&lang=js"
export * from "./HazardView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports